/**
 * Keys for drawer refs that can be focused programmatically when navigating
 * to specific resources from the pre-visit summary.
 */
export enum DrawerRefKey {
  CLIENT_ACTIVITY_CARD = "CLIENT_ACTIVITY_CARD",
  MEASURES_CARD = "MEASURES_CARD",
}
